/**
 * @fileoverview GET handler for the "/engagement/campaigns/global_frequency_caps/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementCampaignsGlobalFrequencyCapsAppGroupId } from "./constants";
import type { CampaignsGlobalFrequencyCapsResults } from "./types";

export const getCampaignsGlobalFrequencyCaps = reactQueryFetcherAdapter(
  engagementCampaignsGlobalFrequencyCapsAppGroupId,
  (signal: AbortSignal, appGroupId: string): Promise<CampaignsGlobalFrequencyCapsResults[]> => {
    return fetch(`/engagement/campaigns/global_frequency_caps/${appGroupId}`, "GET", {}, { signal });
  }
);
